<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs bee-shadow sem-ad-assets {{
		sectionclass
	}}"
	style="position: relative; display: block"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet__header sem-keywords-header">
		<div class="o-stack__cell">
			<div class="card-title keywords-header primary-color">
				<h5>{{ sectiontitle }}</h5>
				<div class="description" *ngIf="hasData">Click on any row under an ad group to view details and ad assets.</div>
				<span class="datatable-icon" *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true" *ngIf="!downloadConfiguration.downloadPNG"></i>
						<img
							src="../../../../../assets/images/Download_Icon.svg"
							class="downloadIcon"
							*ngIf="downloadConfiguration.downloadPNG"
						/>
					</a>
				</span>
			</div>
		</div>
	</div>
	<div class="analytics-portlet-content" *ngIf="hasData">
		<div>
			<div class="container-table">
				<div class="header rows">
					<div
						class="column-name"
						*ngFor="let column of columns; let icon = index"
						(click)="sortDataBasedOnKey(column.columnKey, column.type, icon)"
						[ngClass]="{ active: column.columnKey == sortdataby }"
					>
						<span>{{ column.name }}</span
						><span class="sort-icons">
							<i class="fa fal fa-long-arrow-down"></i><i class="fa fal fa-long-arrow-up"></i>
						</span>
					</div>
				</div>
				<div class="container-table-body">
					<div
						class="adgroups-rows"
						*ngFor="
							let adgroup of formattedData | paginate : { itemsPerPage: itemsPerPage, currentPage: p1 };
							let i = index
						"
					>
						<div class="rows">
							<div class="adgroup-values" *ngFor="let column of columns; let icon = index">
								<span *ngIf="icon == 0">{{ adgroup.adGroup }}</span>
								<span></span>
								<span class="openIcon" *ngIf="icon == 0" (click)="expand('adgroup', i, null, true)">
									<img src="../../../../../assets/images/right_arrow.png" />
								</span>
								<span class="closeIcon" *ngIf="icon == 0" (click)="expand('adgroup', i, null, false)">
									<img src="../../../../../assets/images/right_arrow.png"
								/></span>
							</div>
						</div>
						<div class="ads-details" [ngClass]="{ scroll: adgroup['assets'].length > 6 }">
							<div class="ads-rows" *ngFor="let asset of adgroup['assets']; let k = index" [ngClass]="asset.assetType">
								<div class="rows">
									<div class="ads-values" *ngFor="let column of columns; let icon = index">
										<span class="ad-name" *ngIf="icon == 0 && asset['assetType'] != 'Sitelink'">
											<span>{{ asset['value'] }}</span>
										</span>
										<span class="ad-name" *ngIf="icon == 0 && asset['assetType'] == 'Sitelink'">
											<span *ngFor="let site of asset['value']" class="text">{{ site }} </span>
										</span>
										<span class="ad-name" *ngIf="icon != 0">
											<span *ngIf="column.suffix"
												>{{ asset[column.columnKey] | number : '0.2-2' }}{{ column.suffix }}</span
											>
											<span *ngIf="!column.suffix && column.type == 'number'">{{
												asset[column.columnKey] | number
											}}</span>
											<span *ngIf="column.type == 'string' || !column.type">
												{{ asset[column.columnKey] }}
											</span>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pagination">
					<pagination-template
						#p="paginationApi"
						(pageChange)="p1 = $event"
						*ngIf="formattedData.length > itemsPerPage"
					>
						<ul class="pager">
							<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow" (click)="p.setCurrent(1)">
								<a>
									<i class="fa fa-step-backward icons"></i>
								</a>
							</li>
							<li [class.disabled]="p.isFirstPage()" class="leftStep" style="float: left" (click)="p.previous()">
								<a>
									<img class="arrow_image" src="../../../../../assets/partner-assets/default-r5/icons/left_arrow.png" />
								</a>
							</li>
							<li
								role="button"
								*ngFor="let page of p.pages"
								[class.current]="p.getCurrent() === page.value"
								class="pages"
								style="float: left"
								(click)="p.setCurrent(page.value)"
							>
								<a *ngIf="p.getCurrent() !== page.value">
									{{ page.label }}
								</a>
								<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
									{{ page.label }}
								</a>
							</li>
							<li
								[class.disabled]="p.isLastPage()"
								class="rightStep"
								style="float: left"
								(click)="p.isLastPage() ? '' : p.next()"
							>
								<a>
									<img
										class="arrow_image"
										src="../../../../../assets/partner-assets/default-r5/icons/right_arrow.png"
									/>
								</a>
							</li>
							<li
								[class.disabled]="p.isLastPage()"
								style="float: left"
								class="lastArrow"
								(click)="p.setCurrent(p.getLastPage())"
							>
								<a>
									<i class="fa fa-step-forward icons"></i>
								</a>
							</li>
						</ul>
					</pagination-template>
				</div>
			</div>
		</div>
		<div class="ad-assets-discalimer">
			Note: Many assets can be served with one ad, which leads to more asset impressions in reporting.
			<a *ngIf="resourceLibraryPermission" href="{{ resourceLibrary }}" target="_blank">Learn More</a>
		</div>
	</div>
	<!-- </div> -->
	<!-- when there is no data -->
	<div class="no-data" *ngIf="!hasData">
		<div class="no-data-container">{{ nodatamessage }}</div>
	</div>
	<!-- END of no data div -->
</div>
